import { useEnvContext } from 'next-runtime-env';
import { useGate } from 'statsig-react';

const useOuraGen4Enabled = (): boolean => {
  const env = useEnvContext();
  return (
    useGate('gen4_rollout').value || env['NEXT_PUBLIC_ENABLE_GEN4'] === 'true'
  );
};

export default useOuraGen4Enabled;
